export enum AtomButtonTypeEnum {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  DANGER = "danger",
  DISABLED = "disabled",
  WARNING = "warning",
  OUTLINE = "outline",
}
